import React, { useState, useEffect } from "react";
import Form from "./Childs/Form";
import FormCard from "../../Common/Childs/Structure/FormCard";
import Description from "../../Common/Childs/Structure/Description";
import Title from "../../Common/Childs/Structure/Title";
import { useGlobal } from "../../../context/GlobalContextProvider";

const distroColorAPI = {
  getByCampaign: (campaignId) =>
    fetch(`/api/distrocolor/campaign/${campaignId}`).then((res) => {
      if (res.status === 204 || !res.ok) return null;
      return res.json();
    }),
  update: (campaignId, data) =>
    fetch(`/api/distrocolor/campaign/${campaignId}`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    }),
};

const INITIAL_FORM_STATE = {
  sponsor_color: "#C7C2C0",
  beneficiary_color: "#504C4C",
  artist_color: "#918787",
  seller_color: "#E5DFDD",
  beneficiaryName: [],
  sponsorName: [],
};

const Index = () => {
  const { campaign, setSpinner } = useGlobal();
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);

  useEffect(() => {
    if (!campaign) return;

    const getData = async () => {
      try {
        setSpinner(true);
        const response = await distroColorAPI.getByCampaign(campaign.campaign_id);
        
        if (response) {
          const {
            distro_color_id,
            sponsor_color,
            beneficiary_color,
            artist_color,
            seller_color,
            campaignData: { beneficiaries, sponsories, aps },
          } = response;

          const [{ artists }] = aps;
          const [{ artist_name }] = artists;
          const [{ sponsor_name }] = sponsories;
          const [{ beneficiary_name }] = beneficiaries;

          setFormData({
            distro_color_id,
            sponsor_color: sponsor_color || "",
            beneficiary_color: beneficiary_color || "",
            artist_color: artist_color || "",
            seller_color: seller_color || "",
            beneficiary_name,
            sponsor_name,
            artist_name,
          });
        }
      } catch (error) {
        console.error("Error loading distro colors:", error);
      } finally {
        setSpinner(false);
      }
    };

    getData();
  }, [campaign, setSpinner]);

  const handleSubmit = async (data) => {
    const { sponsor_color, beneficiary_color, artist_color, seller_color } = data;
    try {
      setSpinner(true);
      await distroColorAPI.update(campaign.campaign_id, {
        sponsor_color,
        beneficiary_color,
        artist_color,
        seller_color,
      });
    } catch (error) {
      console.error("Error updating distro colors:", error);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <>
      <Title title="Distro Colors" />
      <Description text="Choose the colors used in funds distribution charts on your Campaign's website." />
      <FormCard>
        <Form formData={formData} handleSubmit={handleSubmit} />
      </FormCard>
    </>
  );
};

export default Index;
